module.exports = __webpack_public_path__ + "static/sampleuniversity-b1a3a84d5524101287f8938d77abf9fe.svg";